const escapeAttribute = (value: string) => value.replace(/&/g, '&amp;').replace(/"/g, '&quot;')

// CSP can't stop a document navigating itself with data in the URL; the shell can, and stays frame-src only as the inner page inherits it.
export const wrapInNavigationGuard = (html: string): string =>
  `<!doctype html><html><head><meta http-equiv="Content-Security-Policy" content="frame-src 'none'"><style>html,body,iframe{display:block;width:100%;height:100%;margin:0;border:0}</style></head><body><iframe sandbox="allow-scripts" srcdoc="${escapeAttribute(
    html,
  )}"></iframe></body></html>`
